/** Mini line chart (80x24) — uma série só, dot no último ponto. */
import { Line, LineChart, ResponsiveContainer } from "recharts";

interface Props {
  data: number[];
  color?: string;
  width?: number;
  height?: number;
}

export function Sparkline({
  data,
  color = "#00DAC8",
  width = 80,
  height = 24,
}: Props) {
  const rows = data.map((v, i) => ({ i, v }));
  const lastIdx = rows.length - 1;
  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={rows} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            dot={(props) => {
              const { cx, cy, index } = props as { cx: number; cy: number; index: number };
              if (index !== lastIdx) return <g key={`sl-${index}`} />;
              return <circle key={`sl-${index}`} cx={cx} cy={cy} r={2.5} fill={color} />;
            }}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
